import { Component, Input, OnInit, ViewChild } from '@angular/core';
import {
  ApexChart,
  ChartComponent,
  ApexNonAxisChartSeries,
  ApexResponsive,
} from 'ng-apexcharts';
import { ActivatedRoute } from '@angular/router';


export type PieChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
};



@Component({
  selector: 'app-peichart',
  templateUrl: './peichart.component.html',
})
export class AppPeiChartComponent implements OnInit {
  @ViewChild('chart') chart: ChartComponent = Object.create(null);
  params;
  salesPerday: Number = 0
  countPerDay: Number = 0
  @Input() pieChartData: Array<any> = []
  @Input() peiLabels: Array<any> = []

  public chartOptions: Partial<PieChartOptions>;


  constructor() {


   
  }
  async ngOnInit(): Promise<any> {
    this.chartOptions = {
      series: this.pieChartData,
      chart: {
        width: 380,
        type: "pie"
      },
      labels: this.peiLabels,
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: "bottom"
            }
          }
        }
      ]
    };
  }
}
